import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import {
  loginUser,
  resetRestorePath,
  resetAuthError
} from 'actions';

import { AuthMode } from 'actions/auth/common';
import withAppErrorBoundary from 'components/ErrorBoundaries/AppErrorBoundary/withAppErrorBoundary';

import LoginForm from 'components/LoginForm';

class Login extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    isAuthenticated: PropTypes.bool.isRequired,
    restorePath: PropTypes.string,
    errorMessage: PropTypes.shape({
      code: PropTypes.number,
      message: PropTypes.string
    }),
    settings: PropTypes.shape(),
    authMode: PropTypes.string.isRequired
  };

  static defaultProps = {
    isFetching: false,
    restorePath: '/',
    errorMessage: null,
    settings: null
  };

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillMount() {
    const { isAuthenticated } = this.props;
    this.checkAndRedirectToHome(isAuthenticated);
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { isAuthenticated } = nextProps;
    this.checkAndRedirectToHome(isAuthenticated);
  }

  checkAndRedirectToHome(isAuthenticated) {
    const { dispatch, restorePath, settings } = this.props;

    if (settings != null && (settings.selectedClient != null || settings.clients == null || settings.clients.length <= 1)) {
      if (isAuthenticated) {
        if (restorePath) {
          dispatch(push(restorePath));
          dispatch(resetRestorePath());
        } else {
          dispatch(push('/'));
        }
      }
    }
  }

  loginUser(creds) {
    const { dispatch } = this.props;
    dispatch(loginUser(creds));
  }

  resetErrorMessage() {
    const { dispatch } = this.props;
    dispatch(resetAuthError());
  }

  render() {
    const {
      isFetching,
      errorMessage,
      authMode
    } = this.props;

    return (
      <div className="login-container">
        <LoginForm
          errorMessage={ errorMessage }
          onSubmit={ creds => this.loginUser(creds) }
          onCloseErrorMessage={ () => this.resetErrorMessage() }
          isFetching={ isFetching }
          showSSOLogin={ authMode !== AuthMode.Manual }
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { auth } = state;
  const {
    isFetching,
    isAuthenticated,
    restorePath,
    errorMessage,
    settings,
    authMode
  } = auth;

  return {
    isFetching,
    isAuthenticated,
    restorePath,
    errorMessage,
    settings,
    authMode
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAppErrorBoundary(Login, 'Login'));
